import { __assign, __read } from "tslib";
import React, { useState } from 'react';
import { Box, IconButton, Flex, Heading, Svg } from '@marvelapp/ui';
function CaretIcon(props) {
    return (React.createElement(Svg, __assign({ display: "block", height: "6px", viewBox: "0 0 10 6", width: "10px" }, props),
        React.createElement("path", { d: "m5 6.00410837c-.26558565.00152002-.52085494-.10283023-.70941946-.29001674l-3.99672938-4c-.39180155-.39212217-.39180155-1.02787783 0-1.42s1.02703738-.39212217 1.41883893 0l3.28730991 3.29 3.28730991-3.29c.39180155-.39212217 1.02703738-.39212217 1.41883893 0 .39180156.39212217.39180156 1.02787783 0 1.42l-3.99672938 4c-.18856452.18718651-.44383381.29153676-.70941946.29001674z" })));
}
export default function SpecsPanel(_a) {
    var children = _a.children, renderLink = _a.renderLink, title = _a.title;
    var _b = __read(useState(true), 2), isOpen = _b[0], setIsOpen = _b[1];
    return (React.createElement(Box, { borderBottom: "1px solid", borderColor: "smoke" },
        React.createElement(Flex, { alignItems: "center", height: 50, justifyContent: "space-between", paddingLeft: 3, paddingRight: 2 },
            React.createElement(Heading, { fontSize: 2, fontWeight: 500 }, title),
            React.createElement(Flex, { alignItems: "center" },
                renderLink && renderLink(),
                React.createElement(IconButton, { marginLeft: 2, onClick: function () { return setIsOpen(!isOpen); } },
                    React.createElement(Box, { transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: "smooth.fast" },
                        React.createElement(CaretIcon, null))))),
        isOpen && (React.createElement(Box, { pb: 3, px: 3 }, children))));
}
